<template>
	<div>
		<div class="actDiv">
			<a-button size="small"  icon="plus" @click="showAddWindow">新增管理员</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="pId" :pagination="false" :scroll="{y:500}">
			<span slot="theAction" slot-scope="text, record">
				<a-button size="small" type="link" @click="editContent(record)">修改</a-button>
				<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(record)">
					<a-button size="small"  type="link">删除</a-button>
				</a-popconfirm>
				<a-button size="small" type="link" @click="editPassword(record)">修改密码</a-button>
				<a-popconfirm title="确定要重置密码?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="resetPassword(record)">
					<a-button size="small" type="link">重置密码</a-button>
				</a-popconfirm>
			</span>
		</a-table>
		<a-modal title="修改密码" :visible="editPasswordFlag" @ok="realEditPassword" @cancel="closeEditPassword"
					cancel-text="取消" ok-text="提交">
			<a-form-model ref="editPwdForm"  :model="editPwdForm" :rules="editPwdFormRules"  :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" >
				<a-form-model-item label="原密码" prop="oldPassword">
					<a-input-password  v-model="editPwdForm.oldPassword"/>
				</a-form-model-item>
				<a-form-model-item label="新密码" prop="newPassword">
					<a-input-password  v-model="editPwdForm.newPassword"/>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-drawer title="新增管理员" :visible="addWindowFlag"  width="500" @close="onAddClose" :destroyOnClose='true' :maskClosable="false">
			<AddUserAdmin @cancelAdd="onAddClose" @refreshList="queryDataList"/>
		</a-drawer>
		<a-drawer title="修改管理员" :visible="editWindowFlag"  width="500" @close="onEditClose()" :destroyOnClose='true' :maskClosable="false">
			<EditUserAdmin :theObj="updateObj" @cancelEdit="onEditClose" @refreshList="queryDataList"/>
		</a-drawer>
	</div>
</template>

<script>
	const columns = [
		{
			title: '用户名',
			dataIndex: 'adminName',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '登录名',
			dataIndex: 'loginName',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '手机',
			dataIndex: 'adminMobile',
			width:100,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '固话',
			dataIndex: 'adminTel',
			width:110,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '邮箱',
			dataIndex: 'adminEmail',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '地址',
			dataIndex: 'adminAddr',
			width:130,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '片区',
			dataIndex: 'departmentName',
			width:180,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
		    title: '操作',
		    key: 'pId',
		    scopedSlots: { customRender: 'theAction' },
			width:240,
			className:'v-cell',
			align:'center',
		  },
	];
	import AddUserAdmin from '../components/AddUserAdmin.vue'
	import EditUserAdmin from '../components/EditUserAdmin.vue'
	export default{
		components:{
			AddUserAdmin,
			EditUserAdmin,
		},
		data(){
			return{
				columns,
				loading:true,
				addWindowFlag:false,
				editWindowFlag:false,
				editPasswordFlag:false,
				list:[],
				updateObj:{},
				editPwdForm:{
					oldPassword:null,
					newPassword:null,
				},
				theAdmin:null,
				editPwdFormRules:{
					oldPassword:[{required:true,message:'请输入原密码',trigger: 'blur'},],
					newPassword:[{required:true,message:'请输入新密码',trigger: 'blur'},],
				},
			}
		},
		methods:{
			editPassword:function(item){
				this.theAdmin = item;
				this.editPasswordFlag = true;
			},
			closeEditPassword:function(){
				this.editPasswordFlag = false;
				this.editPwdForm.oldPassword = null;
				this.editPwdForm.newPassword = null;
				this.theAdmin = null;
			},
			realEditPassword:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.USER_ADMIN_EDIT_PWD_URL);
				let param = {adminId:this.theAdmin.pId,oldPassword:this.editPwdForm.oldPassword,newPassword:this.editPwdForm.newPassword};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("密码修改成功");
						this.closeEditPassword();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			resetPassword:function(item){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.USER_ADMIN_RESET_PWD_URL);
				let param = {adminId:item.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("密码重置成功");
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.USER_ADMIN_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			editContent:function(item){
				this.updateObj = this.Config.deepClone(item);
				this.editWindowFlag = true;
			},
			showAddWindow:function(){
				this.addWindowFlag = true;
			},
			deleteContent:function(item){
				let param = {
					userId:item.pId,
				}
				let url = this.Api.getLastUrl(this.Api.USER_ADMIN_DELETE_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryDataList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				})
			},
			onAddClose:function(){
				this.addWindowFlag = false;
			},
			onEditClose:function(){
				this.editWindowFlag = false;
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
